/* eslint-disable react/prefer-stateless-function */
import React from 'react';
import CreateUser from './CreateUser';

function CreateUserContainer() {
  const onClose = () => {

  };

  return (
    <>
      <CreateUser
        isOpen
        onClose={onClose}
      />
    </>
  );
}

export default CreateUserContainer;
